import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import Sidebar from '../../components/Sidebar/Sidebar';
import PageTitle from '../../components/PageTitle/PageTitle';
import LanguageSelector from '../LanguageSelector/LanguageSelector';
import VideoListStore from '../../store/VideoListStore';
import DateService from '../../services/DateService';
import LanguageStore from '../../store/LanguageStore';
import './header.scss';

const Header = observer(() => {
    const navigate = useNavigate();
    const { language } = LanguageStore;
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);

    const handleLogoClick = (e) => {
        e.preventDefault();
        // Сбрасываем дату на текущий день
        VideoListStore.setTrackedAt(DateService.getTodayFormatedDate());
        // Сбрасываем фильтры
        VideoListStore.setCountryCode('');
        VideoListStore.setOnlyNew(false);
        // Переходим на главную без параметров
        navigate('/');
    };

    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };

    const closeSidebar = () => {
        setIsSidebarOpen(false);
    };

    return (
        <>
            <header className="header">
                <button 
                    className="header__menu-button"
                    onClick={toggleSidebar}
                    aria-label={language === 'ru' ? 'Открыть меню' : 'Open menu'}
                >
                    <span className="header__menu-icon">☰</span>
                </button>

                <div className="container">
                    <Link to="/" onClick={handleLogoClick} className="header__logo-link">
                        <img
                            src="logo.svg"
                            alt="Logo"
                            className="header__logo"
                            width="60"
                            height="60"
                        />
                    </Link>

                    <LanguageSelector/>
                </div>

                <div className="header__title">
                    <PageTitle/>
                </div>
            </header>

            <Sidebar isOpen={isSidebarOpen} onClose={closeSidebar} />
        </>
    );
});

export default Header;